import packageJson from '../../../package.json';
import { env } from '../env';

export const SEGMENT_CDN_URL = 'https://siteusagetools.nerdwallet.com';
export const SEGMENT_API_HOST = 'siteusage.nerdwallet.com/v1';

export const SEGMENT_DEPLOYABLE_NAME = 'satellite';
export const SEGMENT_DEPLOYABLE_VERSION = packageJson.version;

const COMPASS_SEGMENT_STAGE_WRITE_KEY = '8eBuPU067J7tB6g3SgUGKQ1EkkrzkL7i';
const COMPASS_SEGMENT_PROD_WRITE_KEY = 'bnzseKh1j08ce7kemjUaHKUp6JNcyOiR';
export const SEGMENT_WRITE_KEY =
  env.NEXT_PUBLIC_DEPLOYABLE_ENV === 'prod'
    ? COMPASS_SEGMENT_PROD_WRITE_KEY
    : COMPASS_SEGMENT_STAGE_WRITE_KEY;
